var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFd2Img204(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0839844 14.0833C0.0839844 6.30532 6.38931 0 14.1673 0C21.9453 0 28.2507 6.30532 28.2507 14.0833C28.2507 21.8613 21.9453 28.1667 14.1673 28.1667C6.38931 28.1667 0.0839844 21.8613 0.0839844 14.0833Z",
    fill: "#C49A6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3674 15.3676C12.7078 15.3676 13.0343 15.2324 13.2751 14.9917C13.5158 14.7509 13.651 14.4244 13.651 14.084C13.651 13.3754 13.3943 13.0571 13.1376 12.5436C12.5872 11.4433 13.0226 10.4621 14.1645 9.46289C14.4212 10.7465 15.1914 11.9788 16.2183 12.8003C17.2452 13.6219 17.7587 14.5974 17.7587 15.6243C17.7587 16.0963 17.6657 16.5637 17.4851 16.9998C17.3045 17.4358 17.0397 17.8321 16.706 18.1658C16.3722 18.4996 15.976 18.7643 15.5399 18.9449C15.1039 19.1256 14.6365 19.2185 14.1645 19.2185C13.6925 19.2185 13.2251 19.1256 12.7891 18.9449C12.353 18.7643 11.9568 18.4996 11.623 18.1658C11.2893 17.8321 11.0245 17.4358 10.8439 16.9998C10.6633 16.5637 10.5703 16.0963 10.5703 15.6243C10.5703 15.0323 10.7926 14.4465 11.0838 14.084C11.0838 14.4244 11.219 14.7509 11.4597 14.9917C11.7005 15.2324 12.027 15.3676 12.3674 15.3676Z",
    stroke: "#FAF3EC",
    strokeWidth: 1.02691,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFd2Img204);
export default __webpack_public_path__ + "static/media/FD2img204.cdc6bfce2022be1fee30447c09c9c658.svg";
export { ForwardRef as ReactComponent };